const getRandomBetween = (min, max) => Math.floor(Math.random() * ((max + 1) - min) + min);

export default getRandomBetween;
